import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@ncoder/ui';
import { StatusItem } from '../../atoms/training/StatusItem';

interface TrainingStatusPanelProps {
  currentModel: string;
  lastTrained: string;
  trainingTime: string;
}

export const TrainingStatusPanel: React.FC<TrainingStatusPanelProps> = ({
  currentModel,
  lastTrained,
  trainingTime,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Training Status</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <StatusItem label="Current Model" value={currentModel} />
          <StatusItem label="Last Trained" value={lastTrained} variant="muted" />
          <StatusItem label="Training Time" value={trainingTime} />
        </div>
      </CardContent>
    </Card>
  );
};
